module.exports = __webpack_public_path__ + "img/2021etj.64c26d43.jpg";